import HoneybadgerConfig from './Honeybadger';
import PendoConfig from './Pendo';
import { 
  useDatadog
}from './hooks';

export default function Plugins() {
  useDatadog();

  return (
    <>
      <HoneybadgerConfig />
      <PendoConfig />
    </>
  );
}
